// Stub for expo-splash-screen on web. The mobile router calls preventAutoHideAsync,
// setOptions, hideAsync — all no-ops in browser.

const noop = async () => {}
const noopSync = () => {}

module.exports = {
  preventAutoHideAsync: noop,
  hideAsync: noop,
  setOptions: noopSync
}
